import ProductPreview from "./ProductPreview";

export default ProductPreview;